import React from 'react'
import styled, { keyframes } from 'styled-components'
import t from '../data/en_new.json'

import LoadingSVG from './loadingsvg'

const LoadingScreen = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  padding: 2rem;
  opacity: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #15405C;
  color: #ffffff;
  z-index: 999999999;
  text-align: center;
  pointer-events: none;
`

const H2 = styled.h2`
  font-size: 35px;
  font-weight: normal;
`

const Text = styled.p`
  font-size: 1em;
  font-family: 'Sica', sans-serif;
`

const drawOutline = keyframes`
  from {
    stroke-dashoffset: 359;
  }
  to {
    stroke-dashoffset: 0;
  }
`

const ImageContainer = styled.div`
  margin: 1.5rem 0;
  height: 25vh;
  width: 25vh;

  svg {
    height: 100%;
  }

  .cls-1{
    fill: none;
    stroke: #ffffff;
    stroke-dasharray: 359;
    animation: ${drawOutline} 5s linear;
    animation-direction: alternate;
  }
`

const LoadScreen = () => (
  <LoadingScreen className='loadscreen'>
    <H2>{t.loadingScreen.title}</H2>
    <ImageContainer>
      <LoadingSVG />
    </ImageContainer>
    <Text>{t.loadingScreen.body}</Text>
  </LoadingScreen>
)

export default LoadScreen
